// エラーレポート種別
export enum ErrorReportType {
    Complete = 0,       // 完了
    Failed,             // 失敗
}
